document.addEventListener('DOMContentLoaded', ()=>{
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  if ( document.querySelectorAll('.customer__testimonial_swipe').length > 0 ){
    const swiperElementCardSwp = document.querySelector('.customer__testimonial_swipe.swiper');
    if (swiperElementCardSwp) {
      const config = {
        spaceBetween: 18,allowTouchMove: true,slidesPerView: 'auto',grabCursor: true,keyboard: { enabled: true },
        navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'}
      };
      if (!isIOS) {
        config.freeMode = true;
        config.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
      }
      window.cardsSwiperInstance = new Swiper(swiperElementCardSwp, config);
    }  
  }  

  const timelineItems = document.querySelectorAll('.timeline-item');
  const progressDots = document.querySelectorAll('.progress-dot');
  const progressBar = document.getElementById('progressBar');
  const progressContainer = document.querySelector('.progress-container');

  if (progressContainer || progressBar || timelineItems.length != 0 || progressDots.length != 0){
    function debounce(func, wait = 100) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }
    function alignDotsToItems() {
      let cumulativeHeight = 0;
      timelineItems.forEach((item, index) => {
        const itemHeight = item.offsetHeight;
        const itemStyle = window.getComputedStyle(item);
        const marginBottom = parseFloat(itemStyle.marginBottom) || 0;
        if (progressDots[index]) {
          progressDots[index].style.top = `${cumulativeHeight}px`;
        }
        cumulativeHeight += itemHeight + marginBottom;
      });
      updateProgressBarHeight();
      adjustProgressContainerHeight();
    }
  
    function updateProgressBarHeight() {
      const activeDots = Array.from(progressDots).filter(dot => dot.classList.contains('active'));
      if (activeDots.length === 0) {
        progressBar.style.height = '0px';
        return;
      }
      const firstTop = parseFloat(progressDots[0].style.top) || 0;
      const lastActiveDot = activeDots[activeDots.length - 1];
      const lastTop = parseFloat(lastActiveDot.style.top) || 0;
      progressBar.style.top = `${firstTop}px`;
      progressBar.style.height = `${lastTop - firstTop}px`;
    }
  
    function setActiveDotByScroll() {
      const viewportCenter = window.innerHeight / 2;
      let activeIndex = 0;
      let minDistance = Infinity;
      timelineItems.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const itemMiddle = rect.top + rect.height / 2;
        const distance = Math.abs(itemMiddle - viewportCenter);
        if (distance < minDistance) {
          minDistance = distance;
          activeIndex = index;
        }
      });
      timelineItems.forEach((item, index) => {
        const isActive = index <= activeIndex;
        item.classList.toggle('center-stage', index === activeIndex);
        progressDots[index]?.classList.toggle('active', isActive);
      });
      updateProgressBarHeight();
    }
  
    function adjustProgressContainerHeight() {
      const firstDotTop = progressDots[0].offsetTop;
      const lastDot = progressDots[progressDots.length - 1];
      const lastDotTop = lastDot.offsetTop;
      const lastDotHeight = lastDot.offsetHeight;
      const lastDotStyle = window.getComputedStyle(lastDot);
      const lastDotMarginBottom = parseFloat(lastDotStyle.marginBottom) || 0;
      const height = (lastDotTop + lastDotHeight + lastDotMarginBottom) - firstDotTop;
      progressContainer.style.height = `${height}px`;
    }
    const updateLayout = () => {
      alignDotsToItems();
      setActiveDotByScroll();
    };
    const debouncedUpdate = debounce(updateLayout, 100);
    window.addEventListener('scroll', debounce(setActiveDotByScroll, 50));
    window.addEventListener('resize', debouncedUpdate);
    requestAnimationFrame(() => {
      debouncedUpdate();
      setTimeout(debouncedUpdate, 150);
    });
    const observer = new ResizeObserver(debouncedUpdate);
    timelineItems.forEach(item => observer.observe(item));
    let tries = 0;
    const maxTries = 10;
    const retryLoop = () => {
      debouncedUpdate();
      if (++tries < maxTries) {
        setTimeout(retryLoop, 300);
      }
    };
    retryLoop();
  }

  if( document.querySelectorAll('[js-doctor-dietitian-lightbox]').length > 0 ){
    document.querySelectorAll('[js-doctor-dietitian-lightbox]').forEach((elm)=>{
      elm.addEventListener('click',(target)=>{
        target.preventDefault();
        let lighhtbox_doctor = document.querySelector('.doctor_dietitian_lightbox_html').innerHTML;
        document.querySelector('.doctor_dietitian_lightbox').innerHTML = lighhtbox_doctor;
        document.querySelector('.doctor_dietitian_lightbox').classList.add('active');
        document.querySelector('.page-overlay').classList.add('is-visible');
        document.body.classList.add('overflow-hidden');
      })
    })   
  }
  
  class doctorDietitian extends HTMLElement{
    constructor(){
      super();
      this.querySelectorAll('[js-doctor-dietitian-lightbox-close]').forEach((elm)=>{
        elm.addEventListener('click',(target)=>{
          target.preventDefault();
          document.querySelector('.doctor_dietitian_lightbox').innerHTML = ``;
          document.querySelector('.doctor_dietitian_lightbox').classList.remove('active');
          document.querySelector('.page-overlay').classList.remove('is-visible');
          document.body.classList.remove('overflow-hidden');
        })
      })       
    }
  }
  window.customElements.define('cus-dietitian-widget',doctorDietitian);   

  if( document.querySelectorAll('.play_paused___action .action--pause').length > 0 ){
    document.querySelectorAll('.play_paused___action .action--pause').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        target.currentTarget.classList.add('hidden');
        target.target.closest('[js-video-container]').querySelector('.action--play').classList.remove('hidden');
        target.target.closest('[js-video-container]').querySelector('video').pause();
      })
    });
    document.querySelectorAll('.play_paused___action .action--play').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        target.currentTarget.classList.add('hidden');
        target.target.closest('[js-video-container]').querySelector('.action--pause').classList.remove('hidden');
        target.target.closest('[js-video-container]').querySelector('video').play();
      })
    });  
  }  

  if( document.querySelectorAll('[href="#chronic-popup"]').length > 0 ){
    document.querySelectorAll('[href="#chronic-popup"]').forEach(trigger => {
      trigger.addEventListener('click', () => {
        document.querySelector('.chronic-illness-slide-out')?.classList.add('active');
        document.body.classList.add('overflow-hidden');
      });
    });
  } 

  const REVIEW_API_BASE = 'https://api.okendo.io/v1';
  const STORE_ID = 'ddccf316-2614-49f7-8641-7b411da6bacb';
  const COLLECTION_ID = 'c95c5011-c412-4f6c-bc87-cdb7a8e9b16e';
  const INITIAL_API_URL = `${REVIEW_API_BASE}/stores/${STORE_ID}/collections/${COLLECTION_ID}/reviews`;
  const loadMoreReviewsBtn = document.getElementById('load-more-reviews');
  const reviewContainer = document.getElementById('chronic-review-container');
  let nextUrl = null;
  
  function toggleLoadMore(url) {
    if (!loadMoreReviewsBtn) return;
    loadMoreReviewsBtn.classList.toggle('hidden', !url);
  }
  
  function createReviewItem(item) {
    const gridItem = document.createElement('div');
    gridItem.className = 'review-grid-item';
    const avatarUrl = item?.reviewer?.avatarUrl || item?.productImageUrl || '';
    const avatarAlt = item?.reviewer?.displayName || item?.productName || 'avatar';
    const avatar = `<img style="width: 72px; height: 72px; object-fit: cover; border-radius: 5px;" alt="${avatarAlt}" src="${avatarUrl}"> `;
    const ratingPercent = `${(item?.rating || 0) * 20}%`;
    gridItem.innerHTML = `
      <span class="okeReviews-starRating-indicator" role="presentation rating-${item?.rating}">
        <span class="okeReviews-starRating-indicator-layer"></span>
        <span class="okeReviews-starRating-indicator-layer okeReviews-starRating-indicator-layer--foreground" style="width: ${ratingPercent}"></span>
      </span>
      <h3>${item?.title || ''}</h3>
      <p>${item?.body || ''}</p>
      <p style="display: flex; align-items: center; gap: 16px;">${avatar}<span>${item?.reviewer?.displayName || ''}</span></p>
    `;
    return gridItem;
  }
  
  function loadReviews(data, setPosition = false) {
    const reviews = data?.reviews;
    if (!reviews?.length || !reviewContainer) return;
    const fragment = document.createDocumentFragment();
    reviews.forEach(item => {
      const reviewEl = createReviewItem(item);
      fragment.appendChild(reviewEl);
    });
    reviewContainer.appendChild(fragment);
    if (setPosition) {
      const promoBanner = reviewContainer.querySelector('.promo__banner');
      const thirdReview = reviewContainer.querySelectorAll('.review-grid-item')[2];
      if (promoBanner && thirdReview) {
        reviewContainer.insertBefore(promoBanner, thirdReview);
      }
    }
    nextUrl = data?.nextUrl ? `${REVIEW_API_BASE}${data.nextUrl}` : null;
    toggleLoadMore(nextUrl);
  }
  
  async function fetchReviews(url = INITIAL_API_URL) {
    try {
      const response = await fetch(url);
      return await response.json();
    } catch (error) {
      console.error('Error fetching reviews:', error);
      return null;
    }
  }
  
  (async () => {
    const data = await fetchReviews();
    if (data) {
      loadReviews(data, true);
    }
  })();
  
  if (loadMoreReviewsBtn) {
    loadMoreReviewsBtn.addEventListener('click', async () => {
      if (!nextUrl) return;
      loadMoreReviewsBtn.disabled = true;
      const moreData = await fetchReviews(nextUrl);
      if (moreData) {
        loadReviews(moreData);
      }
      loadMoreReviewsBtn.disabled = false;
    });
  } 

  function isInViewport(elem) {
    const rect = elem.getBoundingClientRect();
    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
  
  const stickyBar = document.querySelector('.ci__support_shop_sticky');
  const header = document.querySelector('.section-header');
  const headerHeight = header ? header.clientHeight : 0;
  const addToCartElements = document.querySelectorAll('.timeline__interior_layout');
  const footerSections = document.querySelectorAll('.footer__main_wrapper');
  
  function shouldHideSticky() {
    for (const el of [...addToCartElements, ...footerSections]) {
      if (el && isInViewport(el)) return true;
    }
    return false;
  }
  
  function handleStickyScroll() {
    const scrollY = window.scrollY;
    const triggerElement = document.querySelector('.timeline__interior_layout');
    if (!triggerElement || !stickyBar) return;
    const triggerOffset = triggerElement.offsetTop;
    if (scrollY > triggerOffset) {
      if (shouldHideSticky()) {
        stickyBar.classList.remove('stick__top');
        stickyBar.style.top = `-100%`;
      } else {
        stickyBar.classList.add('stick__top');
        stickyBar.style.top = `${headerHeight}px`;
      }
    } else {
      stickyBar.classList.remove('stick__top');
      stickyBar.style.top = `-100%`;
    }
  }
  window.addEventListener('scroll', handleStickyScroll, { passive: true });  
  
})
